import React from 'react';
import { SingleOption, OptionText, OptionIcon } from './StyledComponents';

export default function Option({
  boldText,
  extraText,
  icon,
  onClick,
  animate,
  style,
}) {
  return (
    <SingleOption
      animate={animate}
      onClick={() => (onClick ? onClick() : console.log('selecting item'))}
    >
      <OptionIcon url={icon} style={style} />
      <OptionText>
        <b>{boldText}</b> {extraText}
      </OptionText>
    </SingleOption>
  );
}
